import { render, staticRenderFns } from "./PredictionLegend.vue?vue&type=template&id=77c44120&"
import script from "./PredictionLegend.vue?vue&type=script&lang=js&"
export * from "./PredictionLegend.vue?vue&type=script&lang=js&"
import style0 from "./PredictionLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports